<template>
  <div class="amendment-information-container card mb-4">
    <div class="card-body">
      <div class="nav-scroller border-bottom">
        <div class="nav nav-tabs">
          <a class="nav-link active" :href="`#amendment-dictums-${uuid}`" data-toggle="tab">Dictámenes de los
                                                                                            comités</a>
          <a class="nav-link" :href="`#amendment-reviewer-dictums-${uuid}`" data-toggle="tab"
             v-if="committee">Dictámenes de revisores</a>
          <a class="nav-link" :href="`#amendment-attachments-${uuid}`" data-toggle="tab">Anexos de la solicitud</a>
          <a class="nav-link" :href="`/enmienda/${amendment.id}/${amendment.type.key}/consultar?ref=historico_protocolo`"
             target="_blank"
             v-if="amendment">Consultar enmienda</a>
        </div>
      </div>
      
      <div class="tab-content">
        <div class="tab-pane fade show active" :id="`amendment-dictums-${uuid}`" role="tabpanel">
          <amendment-dictums :amendment="amendment"
                             v-if="amendment"></amendment-dictums>
        </div>

        <div class="tab-pane fade show" :id="`amendment-reviewer-dictums-${uuid}`" role="tabpanel">
          <amendment-reviewer-dictums :amendment="amendment"
                             v-if="amendment"></amendment-reviewer-dictums>
        </div>
        
        <div class="tab-pane fade" :id="`amendment-attachments-${uuid}`" role="tabpanel">
          <files-list v-if="amendment"
                      :model="amendment"
                      :files="amendment.attachments"
                      :readonly="true"></files-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AmendmentDictums from './AmendmentDictums'
  import AmendmentReviewerDictums from './AmendmentReviewerDictums'
  import FilesList from '../protocols/FilesList'
  import { mapGetters } from 'vuex'
  
  export default {
    name: 'AmendmentInformation',
    components: {
      AmendmentDictums,
      FilesList,
      AmendmentReviewerDictums,
    },
    props: {
      amendment: Object,
      committee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        uuid: Math.guid(),
      }
    },
    computed: {
      ...mapGetters({
        selectedAmendment: 'amendments/selectedAmendment',
      }),
    },
  }
</script>
